export default __webpack_public_path__ + "static/media/Feature2.3020df05.svg";